"use strict";
// ATTENTION: DO NOT ADD REQUIRED() FLAG TO CLAIM SCHEMA
// Required fields are enforced at the end of claim-schema.ts `const submittedClaimSchema = claimSchema.options({ presence: 'required' });`
// This will ensure that all fields not explicitly marked as optional() are required
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.property = void 0;
var joi_1 = __importDefault(require("joi"));
var claim_domain_1 = require("@hobt/claim-domain");
var constants_1 = require("@hobt/constants");
var utils_1 = require("@hobt/utils");
exports.property = joi_1.default.object({
    address: {
        additionalStreetNumber: joi_1.default.string()
            .min(0)
            .max(10)
            .optional()
            .allow(''),
        municipalityName: joi_1.default.string()
            .min(0)
            .max(20),
        postalCode: joi_1.default.string()
            .min(6)
            .max(6)
            .custom(function (postalCode, helper) {
            var errString = 'Postal Code entered does not correspond with the indicated Province / Territory. Please enter a valid postal code.';
            var provinceCode = helper.state.ancestors[0].provinceCode;
            joi_1.default.assert(utils_1.validatePostalCode(provinceCode, postalCode), joi_1.default.boolean().invalid(false), errString);
            return postalCode;
        }),
        provinceCode: (_a = joi_1.default.string()).valid.apply(_a, Object.values(constants_1.StatisticsCanadaProvinceID)),
        streetDirection: (_b = joi_1.default.number()
            .integer()).valid.apply(_b, Object.values(claim_domain_1.StreetDirection)).optional()
            .allow('')
            .allow(null)
            .allow(NaN)
            .options({ convert: false }),
        streetName: joi_1.default.string()
            .min(0)
            .max(30),
        streetNumber: joi_1.default.string()
            .min(0)
            .max(7),
        streetType: (_c = joi_1.default.number()
            .integer()).valid.apply(_c, Object.values(claim_domain_1.StreetType)).optional()
            .allow('')
            .allow(null)
            .allow(NaN)
            .options({ convert: false }),
        unitNumber: joi_1.default.string()
            .min(0)
            .max(6)
            .optional()
            .allow(''),
    },
    bedCount: joi_1.default.number()
        .min(0)
        .max(9999999.99)
        .options({ convert: false })
        .precision(2)
        .optional()
        .custom(function (bedCount, helper) {
        var errString = 'Either bed count or unit count must be present, but not both';
        var unitCount = helper.state.ancestors[0].unitCount;
        if (unitCount === 0) {
            joi_1.default.assert(bedCount, joi_1.default.number()
                .greater(0)
                .required(), errString);
        }
        else {
            joi_1.default.assert(bedCount, joi_1.default.number().valid(0), errString);
        }
        return bedCount;
    }),
    buildingType: joi_1.default.number()
        .integer()
        .when('unitCount', {
        is: joi_1.default.number().greater(2),
        then: joi_1.default.valid(claim_domain_1.BuildingType.Multiples),
        otherwise: joi_1.default.when('unitCount', {
            is: joi_1.default.number().greater(0),
            then: joi_1.default.valid(claim_domain_1.BuildingType.Singles),
        }),
    })
        .when('bedCount', {
        is: joi_1.default.number().greater(0),
        then: joi_1.default.valid(claim_domain_1.BuildingType.Multiples),
    }),
    unitCount: joi_1.default.number()
        .min(0)
        .max(9999999.99)
        .options({ convert: false })
        .precision(2)
        .optional()
        .custom(function (unitCount, helper) {
        var errString = 'Either bed count or unit count must be present, but not both';
        var bedCount = helper.state.ancestors[0].bedCount;
        if (bedCount === 0) {
            joi_1.default.assert(unitCount, joi_1.default.number()
                .greater(0)
                .required(), errString);
        }
        else {
            joi_1.default.assert(unitCount, joi_1.default.number().valid(0), errString);
        }
        return unitCount;
    }),
    completeLegalDescription: joi_1.default.string()
        .min(0)
        .max(1000)
        .optional()
        .allow(''),
});
exports.default = { property: exports.property };
